import { TabsNav } from '@containers/layout'
import { custodySection } from '@services/sections/lib/custody'

export interface CustodyTabsNavProps {
  /**
   * Custom style.
   */
  className?: string
}
export const CustodyTabsNav: React.FC<CustodyTabsNavProps> = ({
  className,
}) => {
  return (
    <TabsNav className={className} sections={[custodySection]} exactMatch />
  )
}
